import Vue from 'vue'
import VeeValidate, { Validator } from 'vee-validate'
import zh from 'vee-validate/dist/locale/zh_CN' // 引入中文文件
Validator.addLocale(zh)
const config = {
    locale: 'zh_CN',
    fieldsBagName: 'fieldBags'
}
Vue.use(VeeValidate, config)

// 自定义validate
const dictionary = {
    zh_CN: {
        messages: {
            required: (field) => field, //请
            numeric: (field) => field + 'Must be numeric.', //必须为数值
            url: () => '请输入正确格式的服务器地址',
            ip: () => '请输入正确的IP地址',
        },
        attributes: {
            extend2_cn: '請選擇瞭解型號',
            extend2_en: 'Missing Interested model',

            cch_cn: '請選擇稱謂',
            cch_en: 'Missing Title',

            surname_cn: '請提交姓氏',
            surname_en: 'Missing Last Name',

            name_cn: '請提交名字',
            name_en: 'Missing First Name',

            sex_cn: '請選擇性別',
            sex_en: 'Missing Gender',

            phone_cn: '請提交手提電話號碼',
            phone_en: 'Missing Mobile no.',

            carBrand_cn: '請選擇品牌',
            carBrand_en: 'Missing select brand',

            audiCarModel_cn: '請選擇Audi 車款型號',
            audiCarModel_en: 'Missing Current Audi Model',

            Privacy1_cn: '請先詳細閱讀並同意隱私政策及聲明。',
            Privacy1_en: 'Please read and agree to the Privacy Policy first.',

            Privacy2_cn: '請先確認此表格內所填報的各項資料準確無誤。',
            Privacy2_en: 'Please declare the information provided in this form is true and correct first.',

            Yn_cn: '你是否 Audi 車主?',
            Yn_en: 'Are you an Audi owner',


            selDate_cn: '請選擇日期',
            selDate_en: 'Please select the date',

            selTime_cn: '請選擇預約時段',
            selTime_en: 'Missing Test drive timeslot',

        }
    }
}
Validator.updateDictionary(dictionary)


Validator.extend('Privacy1_cn_c', {
    messages: {
        zh_CN: field => '請先詳細閱讀並同意隱私政策及聲明'
    },
    validate: value => {
        return /^(true)$/.test(value)
    }
})

Validator.extend('Privacy1_en_c', {
    messages: {
        zh_CN: field => 'Please read and agree to the Privacy Policy first.'
    },
    validate: value => {
        return /^(true)$/.test(value)
    }
})

Validator.extend('Privacy2_cn_c', {
    messages: {
        zh_CN: field => '請先確認此表格內所填報的各項資料準確無誤。'
    },
    validate: value => {
        return /^(true)$/.test(value)
    }
})

Validator.extend('Privacy2_en_c', {
    messages: {
        zh_CN: field => 'Please declare the information provided in this form is true and correct first.'
    },
    validate: value => {
        return /^(true)$/.test(value)
    }
})



// 1.IPV4地址
Validator.extend('ipAddr', {
    messages: {
        zh_CN: field => '请输入正确的IPV4地址'
    },
    validate: value => {
        return /^((25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))$/.test(value)
    }
})

// 2.端口【0~65535】
Validator.extend('port', {
    messages: {
        zh_CN: field => '请输入正确格式的端口号'
    },
    validate: value => {
        return /^([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-4]\d{4}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/.test(value)
    }
})

// 3.用户昵称
Validator.extend('name', {
    messages: {
        zh_CN: field => '用户昵称不允许特殊符号'
    },
    validate: value => {
        return /^[\u4e00-\u9fa5A-Za-z0-9]*$/.test(value)
    }
})

// 4.用户昵称
Validator.extend('phone', {
    messages: {
        zh_CN: field => '手机号格式不正确'
    },
    validate: value => {
        return /^1[2-9]\d{9}$/.test(value)
    }
})

// 5.邮箱
Validator.extend('email_en', {
    messages: {
        zh_CN: field => 'Invalid Email Address.'
    },
    validate: value => {
        return /^[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?$/.test(value)
    }
})

Validator.extend('email_cn', {
    messages: {
        zh_CN: field => '請提交正確的電郵地址'
    },
    validate: value => {
        return /^[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?$/.test(value)
    }
})

// 6.验证码
Validator.extend('code', {
    messages: {
        zh_CN: field => '验证码格式不正确'
    },
    validate: value => {
        return /^[0-9]*$/.test(value)
    }
})

// 6.登录密码
Validator.extend('logpwd', {
    messages: {
        zh_CN: field => '登录密码格式不正确'
    },
    validate: value => {
        return /^\S{6,18}$/.test(value)
    }
})

// 7.交易密码
Validator.extend('tradpwd', {
    messages: {
        zh_CN: field => '交易密码格式不正确'
    },
    validate: value => {
        return /^\S{6,18}$/.test(value)
    }
})

// 8.推荐人
Validator.extend('recom', {
    messages: {
        zh_CN: field => '推荐人格式不正确'
    },
    validate: value => {
        return /^[^\u4e00-\u9fa5]{0,}$/.test(value)
    }
})

// 9.用户协议
Validator.extend('see', {
    messages: {
        zh_CN: field => '请阅读用户协议，并同意'
    },
    validate: value => {
        return true
    }
})

// 10.忘记密码，新的登录密码
Validator.extend('npwd', {
    messages: {
        zh_CN: field => '登录密码格式不正确[6~18位]'
    },
    validate: value => {
        return /^\S{6,18}$/.test(value)
    }
})

// 11.忘记密码，确认新的登录密码
Validator.extend('qrwd', {
    messages: {
        zh_CN: field => '登录密码格式不正确[6~18位]'
    },
    validate: value => {
        return /^\S{6,18}$/.test(value)
    }
})

// 12.车型 
// Validator.extend('modelselect', {
//   messages: {
//       zh_CN: field => '请选择车型'
//   },
//   validate: value => {
//       return /^\S{6,18}$/.test(value)
//   }
// })


// WEBPACK FOOTER //
// ./src/untils/validate.js